// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../cache/REACT_API_PROD/nc_react_ui_node_modules_cache/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../cache/REACT_API_PROD/nc_react_ui_node_modules_cache/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.boldpenguin-aqs-button-nc-custom {
  display: flex;
  align-items: center;
  border-radius: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/bold-penguin-quotation/styles.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AACF","sourcesContent":[".boldpenguin-aqs-button-nc-custom {\n  display: flex;\n  align-items: center;\n  border-radius: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
